import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default function initBenefitsSlider(selector = '.ks-benefits__swiper') {
  const sliders = document.querySelectorAll(selector);

  sliders.forEach((el) => {
    const root = el.closest('.ks-benefits__slider') || el.parentElement;
    const nextEl = root ? root.querySelector('.ks-benefits__nav-next') : null;
    const prevEl = root ? root.querySelector('.ks-benefits__nav-prev') : null;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: { nextEl, prevEl },
      roundLengths: true,
      watchOverflow: true,
      breakpoints: {
        576: { slidesPerView: 2 },
        992: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
        1400: { slidesPerView: 4 },
      },
    });
  });
}
